<div class="footer">
  <a routerLink="/imprint">{{ "FOOTER_LINK_IMPRINT" | translate }}</a>
  <a routerLink="/terms-and-conditions">{{ "FOOTER_LINK_GTC" | translate }}</a>
  <a routerLink="/privacy-policy">{{ "FOOTER_LINK_PP" | translate }}</a>
</div>
